import { useEffect, useMemo, useRef, useState } from 'react';

function OmnivaSelect({
  locations = [],
  selectedLocation = null,
  onSelect,
  isLoading = false,
}) {
  const containerRef = useRef(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setSearchTerm(selectedLocation?.NAME?.[0] || '');
  }, [selectedLocation]);

  const filteredLocations = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return locations;

    return locations.filter((location) => {
      const name = location.NAME?.[0] || '';
      const city = location.A3?.[0] || location.A2?.[0] || '';
      return (
        name.toLowerCase().includes(term) ||
        city.toLowerCase().includes(term)
      );
    });
  }, [locations, searchTerm]);

  const handleValueChange = (event) => {
    setSearchTerm(event.target.value);
    if (!isDropdownVisible) {
      setIsDropdownVisible(true);
    }
  };

  const handleFocus = () => {
    setIsDropdownVisible(true);
    if (!selectedLocation) {
      setSearchTerm('');
    }
  };

  const handleOptionSelect = (location) => {
    onSelect?.(location);
    setIsDropdownVisible(false);
    setSearchTerm(location.NAME?.[0] || '');
  };

  const handleClickOutside = (event) => {
    if (!containerRef.current?.contains(event.target)) {
      setIsDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="omniva-select" ref={containerRef}>
      <label htmlFor="omniva-search">Omniva pickup point</label>
      <input
        id="omniva-search"
        type="text"
        placeholder="Search for a pickup point..."
        value={searchTerm}
        onChange={handleValueChange}
        onFocus={handleFocus}
        className="form-input"
        autoComplete="off"
      />
      {isDropdownVisible && (
        <div className="omniva-dropdown">
          {isLoading ? (
            <div className="omniva-dropdown__status">Loading pickup locations…</div>
          ) : filteredLocations.length ? (
            filteredLocations.map((location) => {
              const key = location.ZIP?.[0] || location.NAME?.[0];
              const city = location.A3?.[0] || location.A2?.[0] || '';
              const street = [location.A5?.[0], location.A7?.[0]]
                .filter(Boolean)
                .join(' ');
              return (
                <button
                  key={key}
                  type="button"
                  className="omniva-dropdown__item"
                  onMouseDown={() => handleOptionSelect(location)}
                >
                  <span className="omniva-dropdown__item-title">{location.NAME?.[0]}</span>
                  <span className="omniva-dropdown__item-meta">
                    {[street, city].filter(Boolean).join(', ')}
                  </span>
                </button>
              );
            })
          ) : (
            <div className="omniva-dropdown__status">No locations found</div>
          )}
        </div>
      )}
    </div>
  );
}

export default OmnivaSelect;

